import { useEffect } from 'react';
import GoogleEvent from '../utils/gaEvent';
import { ProductCardProps } from '../home/types/types';

const useViewItemListEvent = (
  eventName: string,
  itemListId: number | string,
  itemListName: string,
  products: ProductCardProps[] | undefined
) => {
  useEffect(() => {
    const viewItemListEvent = new GoogleEvent(eventName);
    viewItemListEvent.eventParams = {
      item_list_id: itemListId,
      item_list_name: itemListName,
      items: viewItemListEvent.getStructuredItemsFromProducts(products ?? [], itemListId, itemListName),
    };
    viewItemListEvent.sendEvent();
  }, [eventName, itemListId, itemListName, products]);
};

export default useViewItemListEvent;
